import axios from "../../../axios";

export const instancesTime = async () => {
    try {        
        let { data } = await axios.get(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/dashboard/instancesTime`);               
        return data;
    } catch (e) {
        console.log("errors", e)
    }
}
